import React from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import AccountCircle from '@material-ui/icons/AccountCircle';
// import Share from '@material-ui/icons/Share';
import Mic from '@material-ui/icons/MicOutlined';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/icons/Menu';
import Utils from '../../../Utils/Utils';
import Avatar from '@material-ui/core/Avatar';
import Icon from '@material-ui/core/Icon';


class ButtonFiche extends React.Component {
  constructor(props) {
    super(props);
    const paddingX = 20;
    const paddingY = 10;
    this.state = {};
    this.styles = {
		button: {
			padding: 0,
			display: 'flex',
			flexWrap: 'nowrap',
			alignItems: 'stretch',
			border: '1px solid #dadada',
			boxShadow: 'none',
			outline: 'none',
			boxSizing: 'border-box',
			textTransform: 'uppercase',
			position: 'relative',
			color: '#000',
			borderRadius: '5px',
			cursor: 'pointer',
			backgroundColor: props.background,		
			overflow: 'hidden',
			fontWeight: '600'
		},
		text: {
			padding: `${paddingY}px ${paddingX}px`,
			fontSize: '9px',
			lineHeight: '12px',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
      color: Utils.needWhiteText(props.background) ? '#fff' : '#000',
		},
		icon: {
			background: '#fff',
			display: 'block',
			width: '40px',
			position: 'relative',
			marginLeft: '10px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		svg: {
			marginLeft: '-30%',
			width: '80%',
			height: '80%'
		},
		arrow: {
			display: 'block',
			position: 'absolute',
			top: '50%',
			right: '100%',
			border: '18px solid transparent',
			borderRightColor: '#fff',
			transform: 'translateY(-50%)',
		},
		bar: {
			display: 'block',
			width: '2px',
			position: 'absolute',
			top: `${paddingY/2}px`,
			bottom: `${paddingY/2}px`,
			zIndex: 2,
		},
		bar_left: {
			left: `${paddingX/2}px`,
			backgroundColor: '#fff',
		},
		bar_right: {
			right: `${paddingX/2}px`,
			backgroundColor: props.background			
		},
	};
  }

  render() {
    const { children } = this.props;
    console.log('this.props.background', this.props.background);
    //this.styles.button.backgroundColor = this.props.background;
    //this.styles.bar_right.backgroundColor = this.props.background;
    return (
      <button className="button-fiche" style={this.styles.button} >
        <span className="button-fiche__bar" style={{ ...this.styles.bar, ...this.styles.bar_left }}></span>
        <span className="button-fiche__text" style={this.styles.text}>{ window.FICHE_PROFIL || 'FICHE PROFIL'}</span>
        <span className="button-fiche__icon" style={this.styles.icon}>
          <span className="material-symbols-outlined">
          quick_reference
          </span>
          <span className="button-fiche__arrow" style={this.styles.arrow}></span>
        </span>
        <span className="button-fiche__bar" style={{ ...this.styles.bar, ...this.styles.bar_right }}></span>
      </button>
    );
  }
}

const style = {
  selected: {
    backgroundColor: "turquoise !important",
    color: "white",
    fontWeight: 600
  }
};


let Share = ({ref, background = '', ...props}) => {
  // const greatColor = background ? (Utils.needWhiteText(background) ? 'white' : 'black') : '';
  const greatColor = 'black';
  return (<div style={{ border: "0px solid transparent", padding: "4px", marginRight: "5px", color: window.theme.palette.primary.main }} {...props}>
    <span className="material-symbols-outlined ciseaux">
      content_cut
    </span>
  </div>)
};

export default class Chapter extends React.Component {
  
  colors = {
    text: window.theme.palette.background.txt || '#333333',
    background: window.theme.palette.background.paper,
    primary: window.theme.palette.primary.main,
    secondary: window.theme.palette.secondary.main,
  };

  state = {
    current: false,
    currentOdj: false
  }

  progress = {
    backgroundColor: "#aaa",
    minWidth: '20px',
  };

  progressInner = {
    width: '0%',
    height: '100%',
    backgroundColor: this.colors.primary,
    transition: 'width 1000ms linear'
  };
  
  progressOdj = {
    float: 'left',
    width: '100%',
    height: '3px',
    backgroundColor: '#efefef',
    position: 'absolute',
    top: '0px',
    left: '0px'
  };
  
  chapterSpeaker = {
   width: '20px', 
   height: '20px',
   backgroundColor:'#ffffff',
   borderColor: Utils.hexToRGB(window.theme.palette.primary.main, 0.3),
  }
  
  chatperIndex = {
    backgroundColor: "#fff",
    borderColor:this.colors.text
  }
  
  chatperTitle = {
    color: this.colors.text,
    borderColor: this.colors.text,
    fontWeight: 500,
    //backgroundColor: Utils.hexToRGB(this.colors.text, 0.11),
  }
  
  chatperTitleMain = {
    color: this.colors.text,
    borderColor: this.colors.text,
    //backgroundColor: Utils.hexToRGB(this.colors.text, 0.11),
    fontWeight: "bold",
    fontSize: "1rem",
    textTransform: "uppercase",
  }
  
  progressOdjInner = {
    width: '0%',
    height: '100%',
    backgroundColor: this.colors.text,
    transition: 'width 1000ms linear'
  };

  progressPieOdj = {
    borderColor: this.colors.text,
    backgroundColor: "#fff",
    animatioDelay: '-20s'
  }

  progressPieOdjInner = {
    backgroundColor: this.colors.text,
    transform: 'rotate(0deg)'
  }
  
  progressPieOdjHalf = {
    backgroundColor: this.colors.text
  }
  
  progressPieOdjInnerOver50 = {
    backgroundColor: this.colors.primary,
    transform: 'rotate(0deg)'
  }  
  
  seek = (e) => {	  
    window.sdk.player().seek(this.props.chapter.start_second);
	/*setTimeout(() => {
		window.sdk.emit('seeked');
	}, 500);
	setTimeout(() => {
		window.sdk.emit('seeked');
	}, 1000);
	setTimeout(() => {
		window.sdk.emit('seeked');
	}, 1500);*/
  }

  setCurrent(value) {
    this.setState({
      current: value
    });
    if (value) {
      this.showProgress()
    }
    else {
      this.hideProgress()
    }
  }

  showProgress() {
    this.interval = setInterval(() => {
      let time = window.sdk.player().getCurrentTime();
      let e = (time - this.props.chapter.start_second);
      let percent = (e * 100) / this.props.chapter.duration;
      if (document.getElementById('progress')) {
        document.getElementById('progress').style.width = Math.round(percent) + '%';
      }
    }, 1000);
  }

  hideProgress() {
    clearInterval(this.interval);
  }
  
  setCurrentOdj(value) {
    this.setState({
      currentOdj: value
    });
    if(value) {
      this.showProgressOdj()
    }
    else {
      this.hideProgressOdj()
    }
  }
  
  showProgressOdj() {
    if (!this.intervalOdj) {
      this.intervalOdj = setInterval(() => {
        let time = window.sdk.player().getCurrentTime();
        let e = (time - this.props.chapter.start_second);
        let percent = (e * 100) / this.props.chapter.duration;
        //console.log('aniamtion delay "-' + percent + 's"')
        document.getElementById('progress-chapter-odj').style.animationDelay = '-' + percent + 's';
        //document.getElementById('progressOdj').style.width = Math.round(percent) + '%';
        /*let deg = e * 360 / this.props.chapter.duration;
        if(deg > 180){
          deg = deg - 180 ;
          document.getElementById('progress-chapter-odj-inner-over50').style.transform = 'rotate('+deg+'deg)';
          document.getElementById('progress-chapter-odj-inner').style.display = 'none';
        } else {
          document.getElementById('progress-chapter-odj-inner').style.transform = 'rotate('+deg+'deg)';
          document.getElementById('progress-chapter-odj-inner').style.display = 'block';
        }
        if(deg > 89){
          document.getElementById('progress-chapter-odj-half').style.display = 'none';        
        } else {
           document.getElementById('progress-chapter-odj-half').style.display = 'block'; 
        }*/
      }, 1000);
    }
  }
  
  hideProgressOdj() {
    clearInterval(this.intervalOdj);
    this.intervalOdj = null;
  }
  
  share = (e) => {
    e.preventDefault();
    e.stopPropagation();
	
    window.sdk.emit('showExtract', {
      index: this.props.chapter.index
    });
  }
  
  
  showSpeaker = (e) => {
    console.log(e.screenX);
    
    window.entered = false;
    e.preventDefault();
    e.stopPropagation();
    window.sdk.emit('showSpeaker', {
      title: this.props.chapter.title,
      description: this.props.chapter.description,
      id: this.props.chapter.chapter_action,
      x: e.screenX,
      y: e.screenY
    });
    if(this.timeout)
      clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if(!window.entered)
        window.sdk.emit('hideSpeakerPopup');
    }, 2000)
  }

  render() {

    let style, subStyle = {};
    let subStyleOdj1 = {
      fontWeight: 400,
      color: this.colors.text,
    }
    let subStyleOdj2 = {
      color: Utils.hexToRGB(this.colors.text, 0.5),
      fontWeight: 500,
    }

 
    /*if (this.state.current) {
      style = {
        backgroundColor: window.theme.palette.primary.main,
        //color: 'white'
      };
      subStyle = {
        color: 'white'
      }
      subStyleOdj1.color = 'white';
      subStyleOdj2.color = 'white';
    
    } */
    

    //classes={{ selected: style.selected }} className={  ((this.props.chapter.keywords === 'speaker') ? 'speaker ' : '') }
	
	let chatperTitleMainCSS = JSON.parse(JSON.stringify(this.chatperTitleMain));
	if(this.state.currentOdj) {		
		chatperTitleMainCSS.color = this.colors.primary;
    }
	
	let chapterTitleCSS = JSON.parse(JSON.stringify(this.chatperTitle));
	if(this.state.currentOdj) {		
		chapterTitleCSS.color = this.colors.primary;
    }
    

    return (
      <ListItem dense={true} id={ 'chapter-' + this.props.chapter.id } button style={ style } selected={ this.state.current } className={ 'chapter-odj-' + this.props.chapter.odjIndex } onClick={ this.seek }>
        { (this.props.chapter.num > 0  || this.props.chapter.keywords === 'speaker') && <div className="timeline-guide"></div> }
        {/* this.state.currentOdj && 
          <div style={ this.progressOdj }>
            <div id="progressOdj" style={ this.progressOdjInner }><div class="progressOdj-fill"></div></div>
          </div>
      */}
        {(this.state.currentOdj || (this.props.chapter.keywords !== 'speaker' && this.state.current) ) && 
          <style>{`
            .chapter-odj-${this.props.chapter.odjIndex} { background: #ccc; } 
            .chapter-odj-${this.props.chapter.odjIndex} .timeline-guide { border: none; border-left: 5px solid ${ this.colors.primary }; left: 27px; }
            .chapter-odj-${this.props.chapter.odjIndex} .chapter-index { margin-left: 5px; width: 14px; height: 14px; flex: 0 0 14px; }
			.chapter-odj-${this.props.chapter.odjIndex} .chapter-title { color: ${ this.colors.primary } !important; }
          `}</style>}
        
        { this.props.chapter.keywords === 'speaker' &&
          <Avatar  className={ 'chapter-speaker' } style={this.chapterSpeaker} aria-label="Recipe">
            <img  src={'//secure.synople.tv/mediacenter3/speakers/'+this.props.chapter.chapter_action+'.png'}   />
          </Avatar>
        }
        
        { this.props.chapter.keywords === 'speaker' &&
          <ListItemText
            className="chapter-title-speaker"
            disableTypography
            style={ Object.assign({}, subStyleOdj1, window.sdk.isOverlay() ? { paddingRight: 5 } : {}) }
            primary={ <Typography style={{ color: "inherit", fontWeight: "inherit" }}> { this.props.chapter.title }</Typography> }
          />
        }
        { this.props.chapter.keywords !== 'speaker' &&
          <ListItemText
            className="chapter-row"
            disableTypography
            primary={
              <Typography color={(this.state.currentOdj ? 'secondary':'inherit')}  className={this.props.chapter.num > 0 ? "chapter-title-row" : ""}>
                {this.props.chapter.num > 0 && 
                  <React.Fragment>
                    <span className={`chapter-index ${this.state.currentOdj ? 'chapter-index--hide' : ''}`} style={ this.chatperIndex }>{ this.props.chapter.num }</span>
                    { this.state.currentOdj && 
                    <span id="progress-chapter-odj" style={ this.progressPieOdj }></span>
                    }
                  </React.Fragment>
                }
                <span className="chapter-title" style={this.props.chapter.num <= 0 ? chatperTitleMainCSS : chapterTitleCSS }>{ this.props.chapter.title }</span>
              </Typography>
            }
            secondary={ <Typography style={ subStyleOdj2 }> { this.props.chapter.description } </Typography> }
          />
         
        }

        { (this.state.current && this.props.chapter.keywords === 'speaker') && 
          <div style={ this.progress } id="progress-container">
            <span className="material-symbols-outlined">
              mic
            </span>
            <div id="progress" style={ this.progressInner }></div>
          </div>
        }
        <div className="chapter-actions">
          { (this.state.current || this.state.currentOdj) &&
            <Share background={this.state.current ? this.colors.primary : '#aaaaaa'} onClick={ this.share } />
          }
          
          { this.props.chapter.keywords === 'speaker' &&
          <div onClick={ this.showSpeaker } className="speaker-card-btn"  style={{ border: "0px solid transparent", padding: "4px", color: this.colors.primary }}>
            <span className="material-symbols-outlined">
              badge
            </span>
          </div>
          }
        </div>
        
      </ListItem>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Player/Tabs/Odj/Chapter.js